var _defs, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpwardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:#1450ff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.63 2)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "a",
    y1: 14,
    transform: "translate(5.37)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.74,17.37,10.37,12,5,17.37",
    transform: "translate(-5 -11.904)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 18,
    height: 18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpwardIcon);
export default __webpack_public_path__ + "static/media/arrow-upward-icon.a00402ccc862914baa0249669ad126ef.svg";
export { ForwardRef as ReactComponent };